import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

import "@afas-doe-maar/ui/global.css";

Sentry.init({
  dsn: "https://2726f616a6833b0625fe0c732b1f82cb@o395783.ingest.us.sentry.io/4510113847181312",
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
